"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum;
(function (TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum) {
    TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum["LinkStatusUnspecified"] = "DATA_ROLE_LINK_STATUS_UNSPECIFIED";
    TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum["LinkOk"] = "DATA_ROLE_LINK_OK";
    TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum["AccessPermissionDenied"] = "DATA_ROLE_ACCESS_PERMISSION_DENIED";
    TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum["NotFound"] = "DATA_ROLE_NOT_FOUND";
})(TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum = exports.TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum || (exports.TableauNlpSemanticmodelDataRoleAssociationLinkStatusEnum = {}));
function TableauNlpSemanticmodelDataRoleAssociationFromJSON(json) {
    return TableauNlpSemanticmodelDataRoleAssociationFromJSONTyped(json, false);
}
exports.TableauNlpSemanticmodelDataRoleAssociationFromJSON = TableauNlpSemanticmodelDataRoleAssociationFromJSON;
function TableauNlpSemanticmodelDataRoleAssociationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'publishedDatasourceId': !runtime_1.exists(json, 'published_datasource_id') ? undefined : json['published_datasource_id'],
        'siteId': !runtime_1.exists(json, 'site_id') ? undefined : json['site_id'],
        'fieldGraphId': !runtime_1.exists(json, 'field_graph_id') ? undefined : json['field_graph_id'],
        'fieldConceptKey': !runtime_1.exists(json, 'field_concept_key') ? undefined : json['field_concept_key'],
        'associatorId': !runtime_1.exists(json, 'associator_id') ? undefined : json['associator_id'],
        'associatorName': !runtime_1.exists(json, 'associator_name') ? undefined : json['associator_name'],
        'dataRoleName': !runtime_1.exists(json, 'data_role_name') ? undefined : json['data_role_name'],
        'linkStatus': !runtime_1.exists(json, 'link_status') ? undefined : json['link_status'],
        'dataRoleUrl': !runtime_1.exists(json, 'data_role_url') ? undefined : json['data_role_url'],
    };
}
exports.TableauNlpSemanticmodelDataRoleAssociationFromJSONTyped = TableauNlpSemanticmodelDataRoleAssociationFromJSONTyped;
function TableauNlpSemanticmodelDataRoleAssociationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'published_datasource_id': value.publishedDatasourceId,
        'site_id': value.siteId,
        'field_graph_id': value.fieldGraphId,
        'field_concept_key': value.fieldConceptKey,
        'associator_id': value.associatorId,
        'associator_name': value.associatorName,
        'data_role_name': value.dataRoleName,
        'link_status': value.linkStatus,
        'data_role_url': value.dataRoleUrl,
    };
}
exports.TableauNlpSemanticmodelDataRoleAssociationToJSON = TableauNlpSemanticmodelDataRoleAssociationToJSON;
